
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"margin":"auto","background":"#fff"},style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","style":"margin:auto;background:#fff","width":"200","height":"200","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid","display":"block"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(.6 0 0 .6 31 31)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","values":"0;45","keyTimes":"0;1","dur":"0.2s","begin":"0s","repeatCount":"indefinite"}}),_c('path',{attrs:{"d":"M31.36 21.46l7.071 7.072-9.9 9.899-7.07-7.071A38 38 0 017 37.35v10H-7v-10a38 38 0 01-14.46-5.99l-7.072 7.071-9.899-9.9 7.071-7.07A38 38 0 01-37.35 7h-10V-7h10a38 38 0 015.99-14.46l-7.071-7.072 9.9-9.899 7.07 7.071A38 38 0 01-7-37.35v-10H7v10a38 38 0 0114.46 5.99l7.072-7.071 9.899 9.9-7.071 7.07A38 38 0 0137.35-7h10V7h-10a38 38 0 01-5.99 14.46M0-23a23 23 0 100 46 23 23 0 100-46","fill":"#2b938c"}})]),_c('g',{attrs:{"transform":"matrix(.6 0 0 .6 69 69)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","values":"45;0","keyTimes":"0;1","dur":"0.2s","begin":"-0.1s","repeatCount":"indefinite"}}),_c('path',{attrs:{"d":"M-31.36-21.46l-7.071-7.072 9.9-9.899 7.07 7.071A38 38 0 01-7-37.35v-10H7v10a38 38 0 0114.46 5.99l7.072-7.071 9.899 9.9-7.071 7.07A38 38 0 0137.35-7h10V7h-10a38 38 0 01-5.99 14.46l7.071 7.072-9.9 9.899-7.07-7.071A38 38 0 017 37.35v10H-7v-10a38 38 0 01-14.46-5.99l-7.072 7.071-9.899-9.9 7.071-7.07A38 38 0 01-37.35 7h-10V-7h10a38 38 0 015.99-14.46M0-23a23 23 0 100 46 23 23 0 100-46","fill":"#80c242"}})])])
          )
        }
      }
    